<div class="approval-strip">
  <!-- Draft is every week's starting state, so only a submitted or decided week shows a status. -->
  @if (statusKey !== 'registration.status.draft') {
    <span class="approval-status"
          [class.submitted]="week.request?.status === TrackedStatus.Submitted"
          [class.approved]="week.request?.status === TrackedStatus.Approved"
          [class.rejected]="week.request?.status === TrackedStatus.Rejected">{{ statusKey | translate }}</span>
  }
  @if (week.request?.submitted_at) {
    <span class="approval-when">{{ week.request.submitted_at | localedate:'D MMM YYYY HH:mm' }}</span>
  }
  @if (lastRejection; as rej) {
    <span class="approval-reason">
      <nb-icon icon="alert-triangle-outline"></nb-icon>
      {{ rej.reason }}
      <small>{{ 'registration.by' | translate }} {{ rej.actor?.name_first }} {{ rej.actor?.name_last }}, {{ rej.at | localedate:'D MMM YYYY HH:mm' }}</small>
    </span>
  }
  @if (week.request?.status === TrackedStatus.Submitted) {
    <span class="approval-reviewers">{{ 'registration.awaiting_review' | translate:{names: reviewerNames || ('registration.awaiting_review_default' | translate)} }}</span>
  }
  @if ((week.request?.status === TrackedStatus.Approved || week.request?.status === TrackedStatus.Rejected) && decidedByName) {
    <span class="approval-reviewers">{{ 'registration.reviewed_by' | translate:{name: decidedByName} }}</span>
  }
  @if (week.locked) {
    <span class="approval-locked">
      <nb-icon icon="lock-outline"></nb-icon>
      {{ (week.request?.status === TrackedStatus.Approved ? 'registration.locked_approved' : 'registration.locked_submitted') | translate }}
    </span>
  }
  <span class="approval-spacer"></span>
  @if (week.editing) {
    <span class="approval-hint" id="approval-hint">{{ 'registration.finish_trip_first' | translate }}</span>
  }
  <button nbButton size="small" status="primary" [disabled]="!week.canSubmit || busy || week.loading"
          [attr.aria-describedby]="week.editing ? 'approval-hint' : null" (click)="submit()">
    <nb-icon icon="paper-plane-outline"></nb-icon><span>{{ 'registration.submit_week' | translate }}</span>
  </button>
  @if (week.canRecall) {
    <button nbButton size="small" ghost status="basic" [disabled]="busy || week.loading" (click)="recall()">
      <nb-icon icon="undo-outline"></nb-icon><span>{{ 'registration.recall' | translate }}</span>
    </button>
  }
  @if (week.canReopen) {
    <button nbButton size="small" status="warning" [disabled]="busy || week.loading" (click)="reopen()">
      <nb-icon icon="unlock-outline"></nb-icon><span>{{ 'registration.reopen' | translate }}</span>
    </button>
  }
</div>
